import React from 'react'
import trafficFineUtilityPlaceholder from '../../../assets/images/traffic_fine_utility_placeholder.png'

const MAX_UTILITIES = 4

export default function ExpandedUtilitiesSection({
  title = 'Tiện ích mở rộng',
  utilityIcon = trafficFineUtilityPlaceholder,
  utilities = [],
  loading = false
}) {
  const list = (utilities || []).filter((u) => u?.key && u?.label).slice(0, MAX_UTILITIES)
  const showSkeleton = loading && list.length === 0
  const renderList = showSkeleton
    ? Array.from({ length: MAX_UTILITIES }).map((_, idx) => ({
        key: `sk-${idx}`,
        label: '',
        icon: '',
        linkNavigation: '',
        navigationType: 0
      }))
    : list

  if (!loading && !list.length) return null

  const handleNavigate = (u) => {
    if (!u?.linkNavigation) return
    if (u.navigationType === 1 || u.navigationType === 3) {
      window.location.href = u.linkNavigation
    }
  }

  return (
    <div className="traffic-fine-utilities-card">
      <div className="traffic-fine-utilities-title">{title}</div>
      <div className="traffic-fine-utilities-grid">
        {renderList.map((u) => (
          <div
            key={u.key}
            className={`traffic-fine-utility-item ${showSkeleton ? 'is-skeleton' : ''} ${u?.linkNavigation ? 'is-clickable' : ''}`}
            onClick={() => {
              if (showSkeleton) return
              handleNavigate(u)
            }}>
            <div className="traffic-fine-utility-icon">
              {showSkeleton ? (
                <div className="traffic-fine-skeleton-icon" />
              ) : (
                <img src={u.icon || utilityIcon} alt={u.label} loading="lazy" decoding="async" />
              )}
            </div>

            {showSkeleton ? <div className="traffic-fine-skeleton-text" /> : <div className="traffic-fine-utility-label">{u.label}</div>}
          </div>
        ))}
      </div>
    </div>
  )
}
